<template>
    <div class="custom-form-wrapper tw-flex-1 tw-flex tw-items-start">
        <div class="form-content tw-mx-auto tw-mt-8 tw-mb-10 tw-w-auto tw-justify-center tw-flex tw-flex-col tw-flex-1 tw-items-start">
            <div class="tw-flex tw-w-full">
                <div class="tw-flex-1">
                    <slot name="header"></slot>
                </div>
                <div class="header-whitespace tw-ml-14 tw-w-1/4"></div>
            </div>

            <div class="form-content-flex-wrapper tw-flex tw-w-full tw-items-start">
                <div class="form-content-inner tw-flex tw-flex-col tw-flex-1" :class="[contentClass, {'main-form-content-inner-wrapper': mainContent}]">
                    <template v-if="$slots.sidebar && isMobile">
                        <div class="main-content-center">
                            <portal-target name="sidebar" slim></portal-target>
                            <slot name="sidebar"></slot>
                        </div>
                    </template>
                    <slot></slot>
                    <div class="tw-hidden lg:tw-inline-flex md:tw-mb-10" v-if="$slots.actions">
                        <slot name="actions"></slot>
                    </div>
                </div>
                <div class="sidebar-wrapper tw-pt-4 tw-ml-14 tw-flex tw-flex-col" v-if="$slots.sidebar && !isMobile" :class="sidebarClass">
                    <affix style="width: 237.5px;" relative-element-selector=".main-form-content-inner-wrapper" :offset="{top: withStickyTabBar ? 150 : 100, bottom: mobileMarginBottom}" :scroll-affix="true">
                        <div class="sidebar-inner tw-relative tw-flex tw-flex-col">
                            <portal-target name="sidebar" slim></portal-target>
                            <slot name="sidebar"></slot>
                        </div>
                    </affix>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'Form',

        props: {
            mainContent: {
                default: false,
            },
            withStickyTabBar: {
                default: false,
            },
            contentClass: {
                default: '',
            },
            title: {
                default: false,
            },
            subtitle: {
                default: false,
            },
            sidebarClass: {
                default: '',
            },
        },

        computed: {
            ...mapState(['screen_width']),

            mobileMarginBottom() {
                return this.screen_width > 1100 ? 20 : 60;
            },

            isMobile() {
                return this.screen_width <= 767;
            },
        },
    };
</script>

<style lang="scss">
    .custom-form-wrapper {
        &.tw-mt-0 {
            .form-content {
                margin-top: 0;
            }
        }

        .form-content {
            @apply tw-max-w-full;
            max-width: 950px;

            .sidebar-wrapper {
                will-change: min-height;
                width: 237.5px;

                .vue-affix {
                    &:not(.affix) {
                        bottom: auto !important;
                    }
                }

                .sidebar-inner {
                    transform: translate(0, 0); /* For browsers don't support translate3d. */
                    transform: translate3d(0, 0, 0);
                    will-change: position, transform;
                    padding-left: 1px;
                    padding-right: 1px;
                    padding-bottom: 1px;
                    min-height: 100px; // weird fix for affix plugin

                    /* &:after {
                        content: "";
                        bottom: 2.1rem;
                        position: absolute;
                        width: 100%;
                        height: 1px;
                        background: #f8f8f8;
                    } */
                }

                .form-row {
                    @apply tw-ml-0;
                }
            }

            @media(max-width: 1275px) {
                @apply tw-mx-6 tw-max-w-full;
            }

            @media(max-width: 1130px) {
                // max-width: 675px;
                // margin-left: 1rem;

                .sidebar-wrapper {
                    @apply tw-ml-7;
                }
            }

            @media(max-width: 1023px) {
                @apply tw-m-0;
                max-width: none;
            }

            @media(max-width: 767px) {
                .sidebar-wrapper, .header-whitespace {
                    @apply tw-hidden;
                }
            }
        }
    }
</style>
